import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ReactNode } from "react"

interface LayoutState {
    pageTitle: string | ReactNode
    pageHeaderActions: ReactNode | null
    // Where the header's back arrow goes. Null: one level up the path. A page sets
    // it when "one level up" loses state the user came from, such as a list's tab.
    backPath: string | null
}

const initialState: LayoutState = {
    pageTitle: "",
    pageHeaderActions: null,
    backPath: null,
}

const layoutSlice = createSlice({
    name: "layout",
    initialState,
    reducers: {
        setPageTitle: (state, action: PayloadAction<string | ReactNode>) => {
            state.pageTitle = action.payload
        },
        resetLayout: state => {
            state.pageTitle = ""
        },
        setPageHeaderActions: (state, action: PayloadAction<ReactNode | null>) => {
            state.pageHeaderActions = action.payload
        },
        resetPageHeaderActions: state => {
            state.pageHeaderActions = null
        },
        setBackPath: (state, action: PayloadAction<string | null>) => {
            state.backPath = action.payload
        },
    },
})

export const { setPageTitle, resetLayout, setPageHeaderActions, resetPageHeaderActions, setBackPath } = layoutSlice.actions
export default layoutSlice.reducer
